import http from "./HttpService";

const BASE_SERVICE_URL = "organization-service";

export default {
  getBranchDetails({header, branch_uuid}) {
    return new Promise((resolve, reject) => {
      http
        .get(
          `${BASE_SERVICE_URL}/v2/public/branch/${branch_uuid}/details`,
          header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  }
};
